var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPractice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M188.3,77.6c11.9,0,21.7,9.7,21.7,21.7v89c0,11.9-9.7,21.7-21.7,21.7h-89c-11.9,0-21.7-9.7-21.7-21.7v-89 c0-11.9,9.7-21.7,21.7-21.7H188.3 M368.2,77.6c36.5,0,66.2,29.7,66.2,66.2c0,36.5-29.7,66.2-66.2,66.2c-36.5,0-66.2-29.7-66.2-66.2 C302,107.3,331.7,77.6,368.2,77.6 M412.7,302c11.9,0,21.7,9.7,21.7,21.7v89c0,11.9-9.7,21.7-21.7,21.7h-89 c-11.9,0-21.7-9.7-21.7-21.7v-89c0-11.9,9.7-21.7,21.7-21.7H412.7 M188.3,302c11.9,0,21.7,9.7,21.7,21.7v89 c0,11.9-9.7,21.7-21.7,21.7h-89c-11.9,0-21.7-9.7-21.7-21.7v-89c0-11.9,9.7-21.7,21.7-21.7H188.3 M368.2,47.6 c-53.1,0-96.2,43.1-96.2,96.2c0,53.1,43.1,96.2,96.2,96.2c53.1,0,96.2-43.1,96.2-96.2C464.3,90.7,421.3,47.7,368.2,47.6L368.2,47.6z  M188.3,47.6H99.3c-28.5,0-51.6,23.1-51.7,51.7v89c0,28.5,23.1,51.6,51.7,51.7h89.1c28.5,0,51.6-23.1,51.7-51.7v-89 C239.9,70.7,216.8,47.6,188.3,47.6L188.3,47.6z M412.7,272h-89.1c-28.5,0-51.6,23.1-51.7,51.7v89c0,28.5,23.1,51.6,51.7,51.7h89.1 c28.5,0,51.6-23.1,51.7-51.7v-89C464.4,295.2,441.3,272.1,412.7,272L412.7,272z M188.3,272H99.3c-28.5,0-51.6,23.1-51.7,51.7v89 c0,28.5,23.1,51.6,51.7,51.7h89.1c28.5,0,51.6-23.1,51.7-51.7v-89C239.9,295.2,216.8,272.1,188.3,272L188.3,272z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPractice);
export default __webpack_public_path__ + "static/media/practice.af76019e1de0150e2f232c4d38a4fd98.svg";
export { ForwardRef as ReactComponent };